const Menu = [
  { 
  	path: '/', icon: 'fa fa-th', title: 'Inicio'
  }
]
export default Menu;